import './CompanyReferences.scss';
import companyReference from '../../assets/company-reference.png';
import companyReference1 from '../../assets/company-reference1.png';

const CompanyReferences = () => {
  return (
    <div className="company-references">
      <div className="inner-container">
        <p className="title">Company references</p>
        <p className="subtitle">Details and contacts are available upon request.</p>
        <img className="img" src={companyReference1} />
        <p className="title">Team references</p>
        <p className="subtitle">
          Out team members have worked on projects within following companies.
        </p>
        <img className="img" src={companyReference} />
      </div>
    </div>
  );
};

export default CompanyReferences;
